import React from 'react';
import { Upload, Button, Tooltip, Typography, message } from 'antd';
import { UploadOutlined, PaperClipOutlined, CloseOutlined } from '@ant-design/icons';
import { MAX_CHAT_FILE_BYTES, MAX_CHAT_FILE_SIZE_LABEL } from '../helpers/attachmentUtils';

const { Text } = Typography;

const FileUploader = ({ fileList, setFileList }) => {

    const beforeUpload = (file) => {
        if (file.size > MAX_CHAT_FILE_BYTES) {
            message.error(`${file.name} exceeds the ${MAX_CHAT_FILE_SIZE_LABEL} size limit`);
            return Upload.LIST_IGNORE;
        }
        return false;
    };

    const handleChange = ({ fileList: nextFileList }) => {
        const validFiles = nextFileList.filter(
            (f) => (f.size ?? f.originFileObj?.size ?? 0) <= MAX_CHAT_FILE_BYTES
        );
        const uniqueFiles = Array.from(new Map(validFiles.map(f => [f.name, f])).values());
        setFileList(uniqueFiles);
    };

    const handleRemoveByName = (name) => {
        setFileList(prevList => prevList.filter(file => file.name !== name));
    };

    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            alignItems: "center",
            gap: 8,
            maxWidth: "100%",
        }}>
            <Upload
                beforeUpload={beforeUpload}
                multiple
                fileList={fileList}
                onChange={handleChange}
                showUploadList={false}
                accept=".png, .jpg, .jpeg, .doc, .docx, .xls, .xlsx, .pdf"
            >
                <Button icon={<UploadOutlined />}>Select Files</Button>
            </Upload>
            {fileList.map(file => (
                <div
                    key={file.uid}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        background: '#f5f5f5',
                        borderRadius: 16,
                        padding: '4px 8px',
                        maxWidth: 200
                    }}
                >
                    <PaperClipOutlined style={{ marginRight: 6 }} />
                    <Tooltip title={file.name}>
                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 70 }}>
                            {file.name}
                        </span>
                    </Tooltip>
                    <CloseOutlined
                        onClick={() => handleRemoveByName(file.name)}
                        style={{ marginLeft: 8, cursor: 'pointer', color: 'red' }}
                    />
                </div>
            ))}
        </div>
    );
};

export default FileUploader;
